import { styled } from "styled-components";
import theme from "../../theme/theme";

export const CrossContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`;

export const HeaderContainer = styled.h1`
    font-size: 32px;
    color: ${theme.color.navy};
    margin-bottom: 20px;
`;

export const AttributeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AttributeName = styled.span`
  color: #777;
  font-size: 14px;
`;

export const AttributeValue = styled.span`
  color: #000;
  font-size: 18px;
  margin-top: 5px;
  margin-left: 20px;
`;

export const InputsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
    }
`;

export const ImageSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    margin-top: 20px;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const ImageColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SubtitleContainer = styled.h2`
    font-size: 24px;
    font-weight: 400;
    color: ${theme.color.black};
    margin-bottom: 10px;
`;

export const Image = styled.img`
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin: 40px auto 0 auto;
`;